import { TefComs4p } from '@mfe/components/TefComs4p';
import { Purpose } from '@mfec/types/model';
import { html } from 'lit';

//
// renders a single purpose block
//
// {Purpose name}
// {Purpose description}
//   {subscription BLOCK}
export const singlePurposeEdit = function render(this: TefComs4p, purpose : Purpose) : ReturnType<typeof html> {
  return html`
    <h5 class="divider--size-flat">${purpose.title}</h5>
    <p>
      ${purpose.shortDescription}
      ${this.getTemplateFn('tefPurposeDescriptionModal')(purpose)}
    </p>
    ${purpose.subscriptions.map((subscription) => this.getTemplateFn('singleSubscriptionEdit')(subscription))}
  `;
};
